import React from 'react';
import Modal from 'react-bootstrap/Modal';
const PrivacyPolicy = (props) => {
    return (<>

        <Modal
            {...props}
            size="xl"
            aria-labelledby="example-modal-sizes-title-lg"
        >
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
                <div className="terms_container container">
                    <header>
                        <h1>NMT Security Data Privacy Policy</h1>
                        <p className='mb-5'><strong>Effective Date:</strong> Jul 23, 2025</p>
                    </header>
                    <div className='hieght_scroll'>
                        <section>
                            <h2>Overview </h2>
                            <p>At <strong>NMT Security</strong>,your privacy is of utmost importance. This Privacy Policy explains how we collect, process, share, and protect your personal information. By interacting with our website, services, or communication channels, you consent to the terms outlined herein.</p>
                        </section>
                        <section>
                            <h2>Introduction</h2>
                            <p>
                                NMT Security ("we," "our," or "us") is dedicated to safeguarding your personal data through clear and responsible practices. Our goal is to be transparent about how we handle your information, ensuring compliance with global privacy standards.
                            </p>
                            <h2>Information We Collect</h2>
                            <p>a. Personal Information</p>

                            <ul>
                                <li><strong>Identifiers:</strong> Names, job titles, email addresses, phone numbers, company affiliations, and addresses.</li>
                                <li><strong>Account Data:</strong> Login credentials and passwords</li>
                            </ul>

                            <p>b. Technical Information </p>

                            <ul>
                                <li>IP addresses, browser type, operating system, device identifiers, location data, page views, access times, and referring URLs.</li>
                            </ul>

                            <p>c. Communication Records</p>

                            <ul>
                                <li>Emails, phone call recordings, support tickets, chats, surveys, and webinar participation.</li>
                            </ul>
                            <p>d. Recruitment Information </p>

                            <ul>
                                <li>Employment applications, resumes, references, identification documents, and interview records.
                                </li>
                            </ul>

                            <p>e. Security Incident Information
                            </p>

                            <ul>
                                <li>Information from security audits, incident reports, breach data, and vulnerability assessments.
                                </li>
                            </ul>

                            <p>f. Marketing Data </p>

                            <ul>
                                <li>Preferences, subscriptions, marketing responses, and promotional interactions.
                                </li>
                            </ul>
                            <p>g. Cookies and Tracking Data </p>

                            <ul>
                                <li>Cookies, pixels, web beacons, and similar technologies for analytics, site performance, and personalized experiences.
                                </li>
                            </ul>
                           
                        </section>
                        <section>
                            <h2>How We Use Your Information</h2>
                            <p>
                                Your data is utilized to:
                            </p>
                            <ul>
                                <li>Provide and enhance our cybersecurity services.
                                </li>
                                <li>Manage user authentication, accounts, and service access.</li>
                                <li>Identify, investigate, and respond to security incidents and fraud.</li>
                                <li>Communicate important updates, promotional offers, and respond to inquiries.
                                </li>
                                <li>Fulfill legal, regulatory, and contractual obligations.
                                </li>
                                <li>Support recruitment and employment processes.</li>
                                <li>Conduct market research and improve customer experiences.
                                </li>

                            </ul>
                        </section>
                        <section>
                            <h2>Sharing Your Information   </h2>
                            <p>
                                We may disclose information to:
                            </p>
                            <ul>
                                <li>Service providers (cloud services, analytics, payment processing).
                                </li>
                                <li>Legal or regulatory authorities as required by law.
                                </li>
                                <li>Affiliates, subsidiaries, or business partners for operational purposes.
                                </li>
                                <li>Marketing and advertising providers with explicit user consent.</li>

                            </ul>
                        </section>
                        <section>
                            <h2>Security and Compliance
                            </h2>
                            <p>We adhere to rigorous security protocols, including:
                            </p>
                            <ul>
                                <li>Data encryption in transit and at rest.</li>
                                <li>Strong access controls and continuous monitoring.</li>
                                <li>Regular audits, vulnerability assessments, and proactive threat detection.</li>
                                <li>Compliance with SOC 2, ISO 27001, GDPR, HIPAA, PCI DSS standards.
                                </li>

                            </ul>
                        </section>
                        <section>
                            <h2>Data Retention</h2>
                            <p> Your information is retained as long as needed for the outlined purposes. You may request access, correction, or deletion of your personal data, in compliance with applicable laws.
                            </p>
                        </section>
                        <section>
                            <h2> International Transfers
                            </h2>
                            <p>Personal data may be transferred internationally. We ensure appropriate safeguards are in place, such as Standard Contractual Clauses and data protection agreements. </p>
                        </section>
                        <section>
                            <h2>Your Privacy Rights</h2>
                            <p>
                                You may:
                            </p>
                            <ul>
                                <li>Access, rectify, or delete your personal data.
                                </li>
                                <li>Object to or limit specific data processing.
                                </li>
                                <li>Withdraw previously given consent.</li>
                                <li>Opt-out of marketing communications</li>
                                <li>Lodge privacy complaints with relevant authorities.</li>
                            </ul>
                        </section>
                        <section>
                            <h2>Children's Privacy</h2>
                            <p>
                                Our services are not directed to individuals under 18 years old, and we do not knowingly collect or process data from minors.
                            </p>
                        </section>
                        <section>
                            <h2>Incident Management </h2>
                            <p>
                                Security incidents are addressed confidentially with prompt user notifications in line with regulatory requirements and internal policies.
                            </p>
                        </section>
                        <section>
                            <h2>Cookies Policy </h2>
                            <p>We provide transparency regarding cookies usage, offering options to manage or disable cookies through browser settings.
                            </p>
                        </section>
                        <section>
                            <h2>Changes to This Policy</h2>
                            <p>We may periodically update this Privacy Policy. Any significant changes will be clearly communicated on our website and directly to impacted users. </p>
                        </section>
                        <section>
                            <h2>Marketing and Publicity Rights</h2>
                            <p>Use of Name and Logo - Unless otherwise agreed in writing, Customer grants NMT Security a non-exclusive, royalty-free, worldwide license to use Customer’s name, logo, and general description of services provided for the limited purpose of marketing, promotion, and reference in NMT Security’s public materials, including but not limited to its website, case studies, pitch decks, investor presentations, and press releases.</p>
                            <p>Right to Revoke - Customer may revoke this permission at any time by providing written notice to NMT Security. Upon receipt of such notice, NMT Security will promptly cease using the Customer’s name or logo in any new public materials.</p>
                            <p>
                                No Endorsement - Use of Customer’s name or logo does not imply endorsement of NMT Security’s products or services unless separately agreed in writing
                            </p>
                        </section>
                        <section>
                            <h2>Contact Us </h2>
                            <p>
                                For inquiries, requests, or concerns about privacy:
                            </p>
                            <ul>
                                <li> <a href='mailto:info@nmtsecurity.com' className='color_white'><strong>Email: </strong>info@nmtsecurity.com</a>
                                </li>
                            </ul>
                        </section>
                    </div>
                </div>
            </Modal.Body>
        </Modal>

    </>



    );
}
export default PrivacyPolicy;
